import { render, staticRenderFns } from "./SponsorsList.vue?vue&type=template&id=087aa7ee"
import script from "./SponsorsList.vue?vue&type=script&lang=js"
export * from "./SponsorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports